import React from "react";

import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

interface ViewFormProps {
  viewName: string;
  onNameChange: (value: string) => void;
  onSave: () => void;
  saveButtonText?: string;
}

export const ViewForm: React.FC<ViewFormProps> = ({
  viewName,
  onNameChange,
  onSave,
  saveButtonText = "Save",
}) => {
  const isFormValid = viewName.trim().length > 0;

  return (
    <div className="space-y-4 p-2">
      <div className="bg-secondary-n-950 rounded-md p-2">
        <div className="space-y-2">
          <Input
            value={viewName}
            onChange={(e) => onNameChange(e.target.value)}
            placeholder="Name this view"
            className="bg-transparent p-0 h-5 border-none outline-hidden focus:ring-0 focus:outline-hidden focus:border-none focus-visible:ring-0 focus-visible:outline-hidden text-secondary-n-50 placeholder:text-secondary-n-600 text-xs"
          />
        </div>

        <div className="flex justify-end gap-2">
          <Button
            variant="primary"
            onClick={onSave}
            disabled={!isFormValid}
            className="h-7 text-xs font-medium rounded-md"
          >
            {saveButtonText}
          </Button>
        </div>
      </div>
    </div>
  );
};
